import newTranslog from '@/components/NewTrans/index.js'

export default{
    components:{
        newTranslog
    },
    data() {
        return{
            TransLogs:[],
            recordtotal:0,
            pageSize:20,
            pageIndex:1,
            sBillNo:'',
            sDeveliverDtFrom:'',
            sDeveliverDtTo:'',
            sStoreDtFrom:'',
            sStoreDtTo:'',
            sDestination:'',
            sReceiptStatus:'',
            sGoodsStatus:'',
            collapsed:false,

            searchview:[],
            rstatusitems:[
                {Id:'Y',Text:'已回'},
                {Id:'N',Text:'未回'}
            ],
            customers:[],
            carriers:[],
            statusItems:[
                {Id:'C',Text:'无异常'},
                {Id:'L',Text:'多货'},
                {Id:'M',Text:'少货'},
                {Id:'N',Text:'未签收'}
            ],
            reasons:[
                {Id:'R0001',Desc:'未出货'},
                {Id:'R0002',Desc:'保质期'},
                {Id:'R0003',Desc:'破损'},
                {Id:'R0004',Desc:'多货'},
                {Id:'R0005',Desc:'条码异常'},
                {Id:'R0006',Desc:'内包装缺少'},
                {Id:'Other',Desc:'其他'},
            ],
            BackRemarkItems:[
                {Id:'Y',Desc:'已结束'},
                {Id:'N',Desc:'未结束'},
            ],
            CurrentTransLog:[],
            editFormVisible:false,
            CurrentTransLogImages:[],

            searching:false,
            SortDtOder:'',
            DeveliverDtOrder:'',
            fullscreen: false,
            //tableheight: document.body.clientHeight-250
            tableHeight:''
        }
    },
    watch: {
        editFormVisible: {
            handler(newName, oldName) 
            {
                if(newName!=oldName && newName == false)
                {
                    this.refresheditlog(); // 更新当前编辑的对象
                    
                }
            },
        deep: false,
        immediate: false
        },
    },
    mounted () {
        var me = this;
        this.LoadData();
        
        var element = document.getElementById('content');
        this.tableHeight = window.innerHeight - element.offsetTop - 100;
    },
    methods: {
        

        LoadData(){
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            
            this.getcustomers(user);
            this.getcarriers(user);
            this.gettranslogs(user);
        },
        handlesearch(){
            this.searching = true;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            this.gettranslogs(user);
        },
        // 修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            if(row.GoodsStatus == '未签收')
            return 'background-color: #E6E6FA;'
        },
        gettranslogs(user){
            var me = this;
            var getLogsMethod = 'BusinessTrans/getlist';

            var customerids = '';
            me.searchview.CustomerId.forEach(element=>{
                customerids  = customerids + element +',';
            });

            this.$axios.get(getLogsMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName,  
                        'CustomerId': customerids,//me.searchview.CustomerId,
                        'DeveliverDtFrom':me.searchview.DeveliverDtFrom,
                        'DeveliverDtTo':me.searchview.DeveliverDtTo,
                        'BillNo':me.searchview.BillNo,
                        'Destination':me.searchview.Destination,
                        'ReceiptStatus':me.searchview.ReceiptStatus,
                        'Carrier': me.searchview.Carrier,
                        'GoodsStatus':me.searchview.GoodsStatus,
                        'BillNo3':me.searchview.BillNo3,
                        'ProCode':me.searchview.ProCode,
                        'ProName':me.searchview.ProName,
                        'Reason':me.searchview.Reason,
                        'BackRemark':me.searchview.BackRemark,
                        'BillNo2':me.searchview.BillNo2,
                        'StoreDtFrom':me.searchview.StoreDtFrom,
                        'StoreDtTo':me.searchview.StoreDtTo,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                        'SortDtOder':me.SortDtOder,
                        'DeveliverDtOrder':me.DeveliverDtOrder,
                    }
                })
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.TransLogs = response.data.Data.DataSource;
                        me.recordtotal = response.data.Data.TotalRecords;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
                this.searching = false;
            })
            .catch(function (error) {
                this.alert(error);
                this.searching = false;
            });
        },
        getcustomers(user){
            var me = this;
            var getMethod = "common/getcustomerlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.customers = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        getcarriers(user){
            var me = this;
            
            var getMethod = "common/getcarrierlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.carriers = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        refresheditlog(){
            var isSave = sessionStorage.getItem('saveornot');

            if(isSave == 'Y' && this.CurrentTransLog!=null && this.CurrentTransLog!=undefined)
            {
                var me = this;
                var user = sessionStorage.getItem('user');
                if (user) {
                    user = JSON.parse(user);
                }
                var getMethod = "BusinessTrans/get/"+user.TokenId+"/"+user.LoginName+"/"+ this.CurrentTransLog.Id;
                this.$axios.get(getMethod)
                .then((response) => {
                        if(response.data.IsSuccess)
                        {
                            var newLog = response.data.Data;

                            //刷新列表
                            var logs = [];
                            this.TransLogs.forEach(element=>{
                                if(element.Id == this.CurrentTransLog.Id)
                                {
                                    logs.push(newLog);
                                }
                                else
                                {
                                    logs.push(element);
                                }
                            });
                            this.TransLogs = logs;
                    }
                })
                .catch(function (error) {
                    console.log(error)
                });
            }
        },
        handleCurrentChange(val)
        {
            this.pageIndex = val;
            this.LoadData()
        },
        collapse: function() {
            this.collapsed = !this.collapsed;
        },
        formatterController:function(row, column) { 
            var date_str = row[column.property];
            if (date_str === undefined) {
              return "";
            }
            var date = new Date(date_str);
            return date.Format("yyyy-MM-dd");
        },
        formatterDecimal:function(row,column){
            var dig_str = row[column.property];
            if (dig_str === undefined || dig_str == null ) {
              return "";
            }
            var dig = parseFloat(dig_str);
            return dig.toFixed(2);
        },
        handleEdit(row, event){
            this.editFormVisible = true;
            this.CurrentTransLog = Object.assign({}, row);

            sessionStorage.setItem('saveornot', 'N');
            var count = this.CurrentTransLog.TransLogImages.length;

            if(count>0)
            {
                var timages = [];

                this.CurrentTransLog.TransLogImages.forEach(element=>{
                    timages.push({
                        'name':element.FileName,
                        'url': element.FileGuid,
                        'Id' : element.Id,
                        'BusinessTransId' : element.BusinessTransId
                    });
                });

                this.CurrentTransLogImages = timages;
            }
            else
            {
                this.CurrentTransLogImages = [];
            }
        },
        handleDelete(index, row) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              }).then(() => {
                var me = this;
                var user = sessionStorage.getItem('user');
                if (user) {
                    user = JSON.parse(user);
                }
                    var Method = 'BusinessTrans/delete/'+user.TokenId+"/"+user.LoginName+"/"+ row.Id;
                    this.$axios.post(Method)
                    .then((response) => {
                            if(response.data.IsSuccess)
                            {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            
                                var newTrans = [];
                                    
                                me.TransLogs.forEach(element => {
                                    if(element.Id!=row.Id)
                                    newTrans.push(element);
                                    });

                                me.TransLogs = newTrans;
                                me.recordtotal -= 1;
                            }
                            else
                            {
                                var strMsg = '';
                                response.data.Messages.forEach(element => {
                                    strMsg += element.Message +'\r\n';
                                });
                                
                                this.$alert(strMsg);
                            }
                    })
                    .catch(function (error) {
                        this.$alert(error);
                    }); 
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
          },
        querySearch(queryString, cb) {
            var me = this;
            var custs = [];
            if(queryString!='' && queryString!=undefined)
            {
                this.customers.forEach(element=>{
                    if(element.Desc.indexOf(queryString)>-1)
                    custs.push(element);
                });
            }
            // 调用 callback 返回建议列表的数据
            cb(custs);
          }, 
          handleSelect(item) {
            this.searchview.Customer = item.Desc;
          } ,
          querySearchC(queryString, cb) {
            var me = this;
            var custs = [];
            if(queryString!='' && queryString!=undefined)
            {
                this.carriers.forEach(element=>{
                    if(element.Desc.indexOf(queryString)>-1)
                    custs.push(element);
                });
            }
            // 调用 callback 返回建议列表的数据
            cb(custs);
          }, 
          handleSelectC(item) {
            this.searchview.Carrier = item.Desc;
          },
          changeTableSort(column) {
            if (column.prop === 'DeveliverDt') {
               if (column.order === 'descending') {
                   this.DeveliverDtOrder = "Desc";
               } else if (column.order === 'ascending') {
                  this.DeveliverDtOrder = "Asc";
               }
               this.SortDtOder = "";
             } 
             else if (column.prop === 'StoreDt') {
               if (column.order === 'descending') {
                   this.SortDtOder = "Desc";
               } else if (column.order === 'ascending') {
                   this.SortDtOder = "Asc";
               }
               this.DeveliverDtOrder = "";
             } 
             

             this.LoadData();
       },
       fullScreen () {
            var element = document.getElementById('content');
            var requestMethod = element.requestFullScreen 
                ||element.webkitRequestFullScreen 
                ||element.mozRequestFullScreen 
                ||element.msRequestFullScreen;
          if (requestMethod) {
            requestMethod.call(element);
          } 
          else if (typeof window.ActiveXObject !== 'undefined') {
            var wscript = new ActiveXObject('WScript.Shell');
            if (wscript !== null) {
              wscript.SendKeys('{F11}');
            }
        }
        },
        handleFullScreen(){
            var element = document.getElementById('content');
            var totalHeight = document.body.clientHeight; //分辨率宽度
            var tableHeight = (totalHeight - 250);

        // var table = document.getElementById("content");
        //   if (table= undefined && table != null) {
        //     table.style.height = inputWidth + "px";
        //   }
            element.style.height = tableHeight + "px"; 
            element.style.overflow = "auto"; 
            
            if (this.fullscreen) {
              if (document.exitFullscreen) {
                document.exitFullscreen();
              } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
              } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
              }
            } else {
              if (element.requestFullscreen) {
                element.requestFullscreen();
              } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
              } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
              } else if (element.msRequestFullscreen) {
                // IE11
                element.msRequestFullscreen();
              }
            }
            this.fullscreen = !this.fullscreen;
          },
          
    }
}


// WEBPACK FOOTER //
// ./src/components/MaintainTransLog_Sales/MaintainTransLog_Sales.js